import React from 'react'
import styled from "styled-components";

import { AppearRight } from './animations';
import { navData } from '../../utils/navData';
import NavLink from './navLink';

const LinkWrapper = styled.div`
    display: ${props => props.isActive ? 'flex' : 'none'};
    flex-direction: column;
    position: fixed;
    bottom: 88px;
    right: 16px;
    transition: all .3s ease;

    .title {
      font-size: 34px;
      font-family: Space Mono, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      font-weight: bold;
      margin: 16px;
      text-align: right;
      color: #fff;
      animation: ${props => props.isActive ? `${AppearRight} .8s` : ''}
    }
`;

const LinksWrapper = ({ handleItem, isActive}) => (
  <LinkWrapper isActive={isActive} >
    <h1 className="title">MENU</h1>
    {navData.map((obj, i) => (
      <NavLink key={i} delay={i} handleItem={handleItem} title={obj.title} image={obj.image} href={obj.href} />
    ))}
  </LinkWrapper>
);

export default LinksWrapper


// WEBPACK FOOTER //
// ./src/components/MobNav/linksWrapper.js